import { createRouter, createWebHistory } from "vue-router";
import AppLayout from "../layouts/AppLayout.vue";
import BlankLayout from "../layouts/BlankLayout.vue";
import store from "../store/index.js";
import UserLayout from "../layouts/UserLayout.vue";

const routes = [
  {
    path: "/main",
    meta: {
      requiresAuth: true,
    },
    redirect: "/main",
    component: AppLayout,
    children: [
      {
        path: "/",
        name: "Home",
        component: () => import("../views/Dashboard.vue"),
      },
      {
        path: "/accounts",
        name: "Accounts",
        component: () => import("../views/Accounts.vue"),
      },
      {
        path: "/accounts/:id",
        name: "AccountDetails",
        component: () => import("../views/AccountDetails.vue"),
      },
      {
        path: "/admins",
        name: "Admins",
        component: () => import("../views/Admins.vue"),
      },
      {
        path: "/resellers",
        name: "Resellers",
        component: () => import("../views/Resellers.vue"),
      },
      {
        path: "/cards",
        name: "Cards",
        component: () => import("../views/Cards.vue"),
      },
      {
        path: "/cards/groups",
        name: "CardsGroups",
        component: () => import("../views/CardsGroups.vue"),
      },
      {
        path: "/cards/groups/:id",
        name: "GroupCards",
        component: () => import("../views/Cards.vue"),
      },
      {
        path: "/cards/groups/:id/print",
        name: "CardsDesign",
        component: () => import("../views/CardsDesign.vue"),
      },
      {
        path: "/networks",
        name: "Networks",
        component: () => import("../views/Networks.vue"),
      },
      {
        path: "/notifications",
        name: "Notifications",
        component: () => import("../views/Notifications.vue"),
      },
      {
        path: "/profiles",
        name: "Profiles",
        component: () => import("../views/Profiles.vue"),
      },
      {
        path: "/sessions",
        name: "Sessions",
        component: () => import("../views/Sessions.vue"),
      },
      {
        path: "/sessions/online",
        name: "OnlineSessions",
        component: () => import("../views/OnlineSessions.vue"),
      },
      {
        path: "/reports",
        name: "Reports",
        component: () => import("../views/Reports.vue"),
      },
      {
        path: "/settings",
        name: "Settings",
        component: () => import("../views/Settings.vue"),
      },
      {
        path: "/map",
        name: "Map",
        component: () => import("../views/Map.vue"),
      },
      {
        path: "/sales",
        name: "Sales",
        component: () => import("../views/Sales.vue"),
      },
      {
        path: "/groups",
        name: "PrivilegesGroups",
        component: () => import("../views/PrivilegesGroups.vue"),
      },
      {
        path: "/personal",
        name: "Personal",
        component: () => import("../views/Personal.vue"),
      },
      {
        path: "/search",
        name: "Search",
        component: () => import("../views/Search.vue"),
      },
      {
        path: "/user/profile",
        name: "UserProfile",
        component: () => import("../views/UserProfile.vue"),
      },
      {
        path: "/user/subscription",
        name: "UserSubscription",
        component: () => import("../views/UserSubscription.vue"),
      },
      {
        path: "/user/bills",
        name: "UserBills",
        component: () => import("../views/UserBills.vue"),
      },
      {
        path: "/user/alerts",
        name: "UserAlerts",
        component: () => import("../views/UserAlerts.vue"),
      },
      {
        path: "/user/support",
        name: "UserSupport",
        component: () => import("../views/UserSupport.vue"),
      },
      {
        path: "/user/sessions",
        name: "UserSessions",
        component: () => import("../views/UserSessions.vue"),
      },
      {
        path: "/user/usage",
        name: "UserUsage",
        component: () => import("../views/UserUsage.vue"),
      },
      {
        path: "/operations",
        name: "Operations",
        component: () => import("../views/Operations.vue"),
      },
      {
        path: "/bills/resellers",
        name: "ResellersBills",
        component: () => import("../views/ResellersBills.vue"),
      },
      {
        path: "/bills/cards",
        name: "CardsBills",
        component: () => import("../views/CardsBills.vue"),
      },
      {
        path: "/bills",
        name: "Bills",
        component: () => import("../views/Bills.vue"),
      },
      {
        path: "/money-transactions",
        name: "MoneyT",
        component: () => import("../views/MoneyT.vue"),
      },
      {
        path: "/support",
        name: "Support",
        component: () => import("../views/SupportTickets.vue"),
      },
      {
        path: "/mikrotik",
        name: "Mikrotik",
        component: () => import("../views/Mikrotik.vue"),
      },
      {
        path: "/mikrotik/log",
        name: "MikrotikLog",
        component: () => import("../views/MikrotikLog.vue"),
      },
      {
        path: "/bandwidth",
        name: "Bandwidth",
        component: () => import("../views/Bandwidth.vue"),
      },
      {
        path: "/ippublic",
        name: "IpPublic",
        component: () => import("../views/IpPublic.vue"),
      },
      {
        path: "/privatepools",
        name: "PrivatePools",
        component: () => import("../views/PrivatePools.vue"),
      },
      {
        path: "/iptv",
        name: "IPTV",
        component: () => import("../views/Iptv.vue"),
      },
      {
        path: "/sservices",
        name: "SServices",
        component: () => import("../views/SServices.vue"),
      },
      {
        path: "/networks/devices",
        name: "NetworkDevices",
        component: () => import("../views/NetworkDevices.vue"),
      },
      {
        path: "/vpns",
        name: "VpnConnections",
        component: () => import("../views/VpnConnections.vue"),
      },
    ],
  },
  {
    path: "/setup",
    component: BlankLayout,
    meta: {
      requiresAuth: false,
      isSetup: true,
    },
    children: [
      {
        path: "/setup/wizard",
        name: "SetupWizard",
        component: () => import("../views/Wizard.vue"),
      },
    ],
  },
  {
    path: "/auth",
    component: BlankLayout,
    meta: {
      requiresAuth: false,
    },
    children: [
      {
        path: "/login",
        name: "Login",
        component: () => import("../views/Login.vue"),
      },
      {
        path: "/user/login",
        name: "UserLogin",
        component: () => import("../views/Login.vue"),
      },
    ],
  },
  {
    path: "/user",
    component: UserLayout,
    meta: {
      requiresAuth: false,
      requiresUserAuth: true,
    },
    children: [
      {
        path: "/user/subscription",
        name: "UserSubscription",
        component: () => import("../views/UserSubscription.vue"),
      },
      {
        path: "/user/profile",
        name: "UserProfile",
        component: () => import("../views/UserProfile.vue"),
      },
      {
        path: "/user/bills",
        name: "UserBills",
        component: () => import("../views/UserBills.vue"),
      },
      {
        path: "/user/alerts",
        name: "UserAlerts",
        component: () => import("../views/UserAlerts.vue"),
      },
      {
        path: "/user/sessions",
        name: "UserSessions",
        component: () => import("../views/UserSessions.vue"),
      },
      {
        path: "/user/support",
        name: "UserSupport",
        component: () => import("../views/UserSupport.vue"),
      },
      {
        path: "/user/usage",
        name: "UserUsage",
        component: () => import("../views/UserUsage.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  // history: createWebHistory(`/v2`),
  // base: `/v2`,
  routes,
});
router.beforeEach(async (to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ["/login"];
  const userPages = ["user"];
  const authRequired = !publicPages.includes(to.path);
  const userAuthRequired = !userPages.includes(to.path);
  const auth = store.state;

  if (to.matched.some((record) => record.meta.isSetup)) {
    if (!auth.user) await store.dispatch("fetch_user");
    if (!auth.user) {
      next("/");
    }
    next();
  }

  if (to.matched.some((record) => record.meta.requiresUserAuth)) {
    if (!auth.account) await store.dispatch("fetch_account");
    if (userAuthRequired && !auth.account) {
      auth.returnUrl = to.fullPath;
      return next("/user/login");
    } else next();
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!auth.user) await store.dispatch("fetch_user");
    if (authRequired && !auth.user) {
      auth.returnUrl = to.fullPath;
      return next("/login");
    } else {
      if (auth.settings.first_time_login == "1") {
        return next("/setup/wizard");
      }
      next();
    }
  } else {
    if (!auth.user) await store.dispatch("fetch_user");
    if (auth.user) {
      next("/");
    }
    next();
  }
});

export default router;
